import { makeStyles } from "@fluentui/react-components";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  labelField: {
    marginBottom: designTokens.spacing[4],
  },
  helpText: {
    color: designTokens.neutral[500],
    display: "block",
    marginTop: designTokens.spacing[1],
    marginBottom: designTokens.spacing[2],
    minHeight: "40px",
  },
  divider: {
    borderTopWidth: "1px",
    borderTopStyle: "solid",
    borderTopColor: designTokens.neutral[200],
    marginTop: designTokens.spacing[2],
    marginBottom: designTokens.spacing[4],
  },
  sliderRow: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  sliderInput: {
    width: "90px",
    minWidth: "90px",
    flexShrink: 0,
  },
  slider: {
    flexGrow: 1,
    minWidth: 0,
  },
  sliderMax: {
    color: designTokens.neutral[500],
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
});
